export default function LogoIcon(
  props: Pick<
    React.HTMLProps<SVGElement>,
    "width" | "height" | "color" | "className"
  >,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "101"}
      height={props.height || "94"}
      viewBox="0 0 101 94"
      className={props.className}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.9722 2.50273C26.1612 6.11863 11.8675 18.0743 16.5288 37.3465C10.9184 33.6082 0.868245 23.2892 5.5512 11.9189C11.3277 -2.10643 25.5943 -0.977746 33.7335 2.33005C58.9229 -4.03574 106.987 -1.16885 100.337 60.8226C96.759 44.2185 78.4814 9.41887 33.9722 2.50273ZM67.9511 90.8301C75.762 87.2146 90.0567 75.2589 85.3952 55.9861C91.0057 59.7243 101.056 70.0433 96.3728 81.4136C90.5966 95.4385 76.3307 94.3104 68.1914 91.0029C43.0021 97.3688 -5.06237 94.5023 1.58688 32.5104C5.16534 49.1144 23.4427 83.9136 67.9511 90.8301ZM53.3304 24.8975C52.8554 22.9673 50.1112 22.9673 49.6362 24.8975L46.1463 39.0791C45.9781 39.7624 45.4465 40.297 44.7641 40.469L30.665 44.0233C28.7487 44.5064 28.7487 47.2292 30.665 47.7123L44.7641 51.2665C45.4465 51.4385 45.9781 51.9732 46.1463 52.6565L49.6362 66.8381C50.1112 68.7683 52.8554 68.7683 53.3304 66.8381L56.8203 52.6565C56.9885 51.9732 57.5201 51.4385 58.2024 51.2665L72.3016 47.7123C74.2179 47.2292 74.2179 44.5064 72.3016 44.0233L58.2024 40.469C57.5201 40.297 56.9885 39.7624 56.8203 39.0791L53.3304 24.8975Z"
        fill={props.color || "#9D89FC"}
      />
    </svg>
  );
}
